import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'


export default StyleSheet.create({
  containerStyle: (theme, insets) => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColor,
    paddingBottom: insets.bottom + 10,
    paddingHorizontal: 16.2,
  }),
  closeButtonContainer: insets => ({
    alignSelf: 'flex-end',
    marginTop: insets.top,
  }),
  scrollViewContentContainStyle: {
    flex: 1,
    justifyContent: 'space-between',
  },
  contentStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  lottieViewContainerStyle: {
    marginVertical: 32,
  },
  lottieViewStyle: {
    width: 125,
    height: 125,
  },
  titleStyle: theme => ({
    ...Fonts.type.bold,
    color: theme.colors.textColorSeven,
    fontSize: 29.1,
    marginBottom: 29.1,
    textAlign: 'center'
  }),
  subTitleStyle: theme => ({
    color: theme.colors.headerTitleColor,
    fontSize: 18.7,
    lineHeight: 25,
  }),
  dateTextStyle: theme => ({
    ...Fonts.type.bold,
    fontSize: 18.7,
    lineHeight: 25,
    color: theme.colors.headerTitleColor,
  }),
  storeInfoContainerStyle: theme => ({
    marginTop: 31.7,
    marginBottom: 30,
    paddingHorizontal: 15.6,
    borderColor: theme.colors.borderColorThree,
  }),
  storeInfoIconStyle: {
    marginRight: 16,
    marginLeft: 17,
  },
  addToCalanderButtonStyle: {
    width: '100%',
    marginBottom: 12.4,
  },
  appointmentsButtonStyle: {
    width: '100%',
  },
  addToCalenderDisabledStyle: theme => ({
    backgroundColor: theme?.colors?.buttons?.disabledThree,
  }),
  addToCalenderDisabledTextStyle: theme => ({
    color: theme?.colors?.textColor
  }),
})
